import UserMenu from '../UserMenu/UserMenu'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { useState } from 'react'
import getTestId from 'utils/getTestId'

import style from './User.module.css'

const User: React.FC<{ email?: string; firstName?: string; lastName?: string }> = ({ email, firstName, lastName }) => {
  const [open, setOpen] = useState(false)

  const onClick = (): void => {
    setOpen(prev => !prev)
  }

  const onClickAway = (): void => {
    setOpen(prev => !prev)
  }

  const initials =
    [firstName?.charAt(0), lastName?.charAt(0)].filter(Boolean).join('').toUpperCase() ||
    email?.substring(0, 2).toUpperCase()

  return (
    <div className={style.userMenuBlock} onClick={onClick} data-test-id={getTestId('user-avatar')}>
      <div className={style.avatar}>
        <span className={style.avatarText} data-test-id={getTestId('avatar-text')}>
          {initials}
        </span>
      </div>
      {open ? (
        <ClickAwayListener onClickAway={onClickAway}>
          <UserMenu />
        </ClickAwayListener>
      ) : null}
    </div>
  )
}

export default User
